import { css } from "styled-components";

/**
 * 모달 크기 공통 규칙 (2026-10-02).
 * 화면이 작아도 모달 상자가 화면 밖으로 나가지 않게 최대 높이를 화면 높이에 묶는다.
 * 내용이 화면 안에 들어가는 모달은 아무것도 바뀌지 않는다. 넘칠 때만 상자(또는 본문)가 스크롤된다.
 * 세로/가로 배치는 바꾸지 않는다.
 */
export const modalLayout = {
  // 화면 위아래 여백 합계
  viewportGap: "48px",
  // ModalShell 배경 층. 기존 공통 확인 모달(common/ConfirmModal)과 같다
  zIndex: 10000,
} as const;

// 상자 자체가 스크롤되는 단순한 모달
export const modalBoxScroll = css`
  max-height: calc(100dvh - ${modalLayout.viewportGap});
  overflow-y: auto;
`;
